import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const routes = [
    {
        path: '/access',
        name: 'access',
        component: () => import('../pages/Access.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../pages/Login.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import('../pages/SignUp.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/reset-password',
        name: 'reset password',
        component: () => import('../pages/ResetPassword.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('../pages/UserInfo.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/client-intake',
        name: 'ClientIntake',
        component: () => import('../pages/ClientIntake.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/client-overview',
        name: 'Client Overview',
        component: () => import('../pages/ClientOverview.vue'),
        meta: {
            requiresAuth: true,
        },
        props: true,
    },
    {
        path: '/list-generation',
        name: 'List Generation',
        component: () => import('../pages/ListGen.vue'),
        meta: {
            requiresAuth: true,
        },
        props: true,
    },
    {
        path: '/match-list',
        name: 'Match List',
        component: () => import('../pages/MatchList.vue'),
        meta: {
            requiresAuth: true,
        },
        props: true,
    },
    {
        path: '/user-queries',
        name: 'User Queries',
        component: () => import('../pages/UserQueries.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/candidate-search',
        name: 'Candidate Search',
        component: () => import('../pages/CandidateSearch.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/list-enforcement',
        name: 'List Enforcement',
        component: () => import('../pages/ListEnforcement.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/apical-oauth-callback',
        name: 'apical-oauth-callback',
        component: () => import('../pages/ApicalOAuthCallback.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('../pages/Error.vue'),
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('../pages/NotFound.vue'),
    },
    {
        path: '/:catchAll(.*)',
        redirect: { name: 'List Generation' },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (await store.getters.isAuthenticated) {
            next();
        } else {
            next('/access');
        }
    } else {
        next();
    }
});

export default router;
